module.exports = __webpack_public_path__ + "4777fa3a2359d5fd875b3fdf18f88f71.pdf";